import React from 'react';
import { companyInfo } from '../../data/mockData';

export const HeaderLogo = () => (
  <div className="logo">
    <img
      src="https://customer-assets.emergentagent.com/job_dba9b77f-2bec-4d59-9c0d-9f2fc088db35/artifacts/528cb74a_logo.jpg"
      alt="SS Consultancy Logo"
      style={{ height: '2.4rem', width: 'auto' }}
    />
    <div>
      <div style={{ fontWeight: 700, fontSize: '1.15rem', color: 'var(--primary-navy)' }}>
        {companyInfo.name}
      </div>
      <div style={{ fontSize: '0.7rem', color: 'var(--text-muted)', fontWeight: 500, letterSpacing: '0.04em' }}>
        Wealth · Tax · Retirement
      </div>
    </div>
  </div>
);
